class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.productOptions = this.form.querySelectorAll(
      '.product-options [name*="option"]'
    );
    this.atcBtn = this.form.querySelector(".btn-atc");
    this.buyBtn = this.form.querySelector(".btn-buy");

    this.form.addEventListener("submit", (event) => this.onSubmit(event));

    this.productOptions.forEach((elem) =>
      elem.addEventListener("change", (event) =>
        this.onChangeProductOption(event)
      )
    );

    this.buyBtn?.addEventListener("click", (event) =>
      this.onClickBuyBtn(event)
    );

    this.querySelectorAll('select[name="id"').forEach((select) => {
      select.addEventListener("change", () => this.onChangeVariant(select));
    });

    this.handleOutOfStockOptions();
  }

  async onChangeProductOption(event) {
    event.preventDefault();

    const selectedOptions = [];

    this.productOptions.forEach((elem) => {
      if (elem.type === "radio" && elem.checked) {
        selectedOptions.push(elem.value);
      } else if (elem.type === "select-one") {
        selectedOptions.push(elem.value);
      }
    });

    // console.log(selectedOptions)

    const selectedVariant = JSON.parse(this.form.dataset.variants).find(
      (variant) =>
        JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
    );

    console.log(selectedVariant);

    this.adjustPricing(selectedVariant);
    this.adjustButtons(selectedVariant);
    this.handleOutOfStockOptions();

    if (selectedVariant) {
      this.querySelector('[name="id"]').value = selectedVariant.id;

      if (this.closest(".product-main")) {
        const url = new URL(window.location);
        url.searchParams.set("variant", selectedVariant.id);
        window.history.replaceState({}, "", url);
      }

      window.dispatchEvent(
        new CustomEvent("kt.product.variant.change", {
          detail: selectedVariant,
        })
      );

      this.fetchNewDocument(selectedVariant);
    }
  }

  adjustPricing(selectedVariant) {
    if (!selectedVariant) return;

    const comparePrice = this.form.querySelector(".product-price-compare");
    const finalPrice = this.form.querySelector(".product-price-final");
    const compareBadge = this.form.querySelector(".product-sale-badge");
    const soldOutBadge = this.form.querySelector(".product-sold-out-badge");

    if (selectedVariant.compare_at_price > selectedVariant.price) {
      comparePrice.textContent = window.Shopify.formatMoney(
        selectedVariant.compare_at_price
      );
      comparePrice.removeAttribute("hidden");
      finalPrice.innerHTML = `<span class="visually-hidden">${
        window.theme.locales.product.sale_price
      }}</span>${window.Shopify.formatMoney(selectedVariant.price)}`;
      finalPrice.classList.add("product-price-final-sale");
      compareBadge.removeAttribute("hidden");
      if (compareBadge.dataset.discountType === "percentage") {
        const savings =
          100 -
          Math.round(
            (selectedVariant.price / selectedVariant.compare_at_price) * 100
          ) +
          "%";
        compareBadge.textContent = `${window.theme.locales.product.save} ${savings}`;
      } else {
        const savings = window.Shopify.formatMoney(
          selectedVariant.compare_at_price - selectedVariant.price
        );
        compareBadge.textContent = `${window.theme.locales.product.save} ${savings}`;
      }
    } else {
      comparePrice.textContent = "";
      comparePrice.setAttribute("hidden", "hidden");
      finalPrice.innerHTML = window.Shopify.formatMoney(selectedVariant.price);
      finalPrice.classList.remove("product-price-final-sale");
      compareBadge.textContent = "";
      compareBadge.setAttribute("hidden", "hidden");
    }

    if (selectedVariant.available) {
      soldOutBadge.setAttribute("hidden", "hidden");
    } else {
      soldOutBadge.removeAttribute("hidden");
    }
  }

  adjustButtons(selectedVariant) {
    if (selectedVariant) {
      if (selectedVariant.available) {
        this.atcBtn.removeAttribute("disabled");
        this.buyBtn?.removeAttribute("disabled");
        this.atcBtn.innerHTML = window.theme.locales.product.add_to_cart;
      } else {
        this.atcBtn.setAttribute("disabled", "disabled");
        this.buyBtn?.setAttribute("disabled", "disabled");
        this.atcBtn.innerHTML = window.theme.locales.product.sold_out;
      }
    } else {
      this.atcBtn.setAttribute("disabled", "disabled");
      this.buyBtn?.setAttribute("disabled", "disabled");
      this.atcBtn.innerHTML = window.theme.locales.product.unavailable;
    }
  }

  async fetchNewDocument(selectedVariant) {
    const respoonse = await fetch(
      `${this.form.dataset.productUrl}?variant=${selectedVariant.id}`
    );
    const text = await respoonse.text();
    const newDocument = new DOMParser().parseFromString(text, "text/html");

    window.dispatchEvent(
      new CustomEvent("kt.product.variant.change.newDoc", {
        detail: newDocument,
      })
    );
  }

  async onSubmit(event) {
    event.preventDefault();

    this.atcBtn.classList.add("loading");
    this.atcBtn.disabled = true;
    this.atcBtn.setAttribute("aria-busy", "true");

    const formData = new FormData(this.form);

    await document.querySelector("cart-container").add(formData);

    this.atcBtn.classList.remove("loading");
    this.atcBtn.disabled = false;
    this.atcBtn.setAttribute("aria-busy", "false");
  }

  onClickBuyBtn() {
    this.buyBtn.classList.add("loading");
    const variantId = this.form.querySelector('[name="id"]').value;
    const qty = Number(
      this.form.querySelector('input[name="quantity"]')?.value || 1
    );
    window.location.href = `/cart/${variantId}:${qty}`;
  }

  onChangeVariant(select) {
    const variantImage = select[select.selectedIndex].dataset.variantImage;

    if (variantImage.length) {
      select
        .closest(".product-card")
        .querySelector(".product-card-img-wrapper img")
        .setAttribute("src", variantImage);
    }
  }

  handleOutOfStockOptions() {
    if (!this.form.dataset.variants) return;

    const variants = JSON.parse(this.form.dataset.variants);
    // console.log(variants)

    const selectedOption1 = this.form.querySelector(
      'input[data-option-position="1"]:checked'
    )?.value;
    const selectedOption2 = this.form.querySelector(
      'input[data-option-position="2"]:checked'
    )?.value;
    const selectedOption3 = this.form.querySelector(
      'input[data-option-position="3"]:checked'
    )?.value;

    this.form
      .querySelectorAll('input[data-option-position="1"]')
      .forEach((input) => {
        const correspondingVariant = variants.find((variant) => {
          if (selectedOption3) {
            if (
              variant.option1 === input.value &&
              variant.option2 === selectedOption2 &&
              variant.option3 === selectedOption3
            )
              return variant;
          } else if (selectedOption2) {
            if (
              variant.option1 === input.value &&
              variant.option2 === selectedOption2
            )
              return variant;
          } else {
            if (variant.option1 === input.value) return variant;
          }
          return null;
        });

        if (correspondingVariant?.available) {
          input.classList.remove("disabled");
        } else {
          input.classList.add("disabled");
        }
      });

    this.form
      .querySelectorAll('input[data-option-position="2"]')
      .forEach((input) => {
        const correspondingVariant = variants.find((variant) => {
          if (selectedOption3) {
            if (
              variant.option2 === input.value &&
              variant.option1 === selectedOption1 &&
              variant.option3 === selectedOption3
            )
              return variant;
          } else {
            if (
              variant.option2 === input.value &&
              variant.option1 === selectedOption1
            )
              return variant;
          }
          return null;
        });

        if (correspondingVariant?.available) {
          input.classList.remove("disabled");
        } else {
          input.classList.add("disabled");
        }
      });

    this.form
      .querySelectorAll('input[data-option-position="3"]')
      .forEach((input) => {
        const correspondingVariant = variants.find((variant) => {
          if (
            variant.option3 === input.value &&
            variant.option1 === selectedOption1 &&
            variant.option2 === selectedOption2
          )
            return variant;
          return null;
        });

        if (correspondingVariant?.available) {
          input.classList.remove("disabled");
        } else {
          input.classList.add("disabled");
        }
      });
  }
}
customElements.define("product-form", ProductForm);

class ProductMediaGallery extends HTMLElement {
  constructor() {
    super();

    const initialSlide = Number(this.dataset.initialSlide);

    /** @type {Swiper} */
    this.thumbs = new window.Swiper(
      this.querySelector(".swiper-thumbs"),
      this.thumbsOptions()
    );

    /** @type {Swiper} */
    this.main = new window.Swiper(
      this.querySelector(".swiper-main"),
      this.mainOptions()
    );

    this.main.slideTo(initialSlide);

    this.setStickyPosition();
    this.listenVariantChange();
    this.initFullScreenGallery();
  }

  thumbsOptions() {
    /** @type {SwiperOptions} */
    const options = {
      slidesPerView: Number(this.dataset.thumbsPerView),
      spaceBetween: 10,
      mousewheel: true,
    };
    return options;
  }

  mainOptions() {
    /** @type {SwiperOptions} */
    const options = {
      effect: this.dataset.effect,
      speed: Number(this.dataset.speed),
      rewind: true,
      pagination: {
        type: this.dataset.paginationType,
        el: ".swiper-pagination",
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`;
        },
      },
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
      thumbs: {
        swiper: this.thumbs,
        autoScrollOffset: 1,
      },
      cubeEffect: {
        shadow: false,
      },
      creativeEffect: {
        prev: {
          shadow: true,
          origin: "left center",
          translate: ["-5%", 0, -200],
          rotate: [0, 100, 0],
        },
        next: {
          origin: "right center",
          translate: ["5%", 0, -200],
          rotate: [0, -100, 0],
        },
      },
      scrollbar: {
        enabled: this.dataset.scrollbar === "true",
        el: this.querySelector(".swiper-scrollbar"),
        draggable: true,
        hide: true,
      },
      breakpoints: {
        0: {
          slidesPerView:
            1 * (this.dataset.partialSlidesMobile === "true" ? 1.2 : 1),
        },
        600: { slidesPerView: 1 },
      },
      on: {
        slideChange: this.onSlideChange.bind(this),
      },
    };
    return options;
  }

  onSlideChange() {
    this.querySelectorAll("video").forEach((video) => video.pause());

    setTimeout(() => {
      if (this.querySelector(".swiper-main .swiper-slide-active video")) {
        this.querySelector(".swiper-main-wrapper").setAttribute(
          "data-active-slide-is-video",
          "true"
        );
      } else {
        this.querySelector(".swiper-main-wrapper").setAttribute(
          "data-active-slide-is-video",
          "false"
        );
      }
    }, 500);
  }

  setStickyPosition() {
    if (
      this.closest(".product-main") &&
      window.matchMedia("(min-width: 1200px)").matches
    ) {
      const headerGroup = document.querySelector("#header-group.sticky-top");
      const pdpExtraContent = document.querySelector("#pdp-extra-content");

      let oldScroll = window.scrollY;

      window.addEventListener("scroll", () => {
        const newScroll = window.scrollY;
        if (newScroll > oldScroll) {
          if (newScroll > headerGroup.clientHeight) {
            this.style.top = "20px";
            if (pdpExtraContent) {
              document.querySelector("#pdp-extra-content").style.top = "20px";
            }
          }
        } else if (newScroll < oldScroll) {
          this.style.top = `${headerGroup.clientHeight + 20}px`;
          if (pdpExtraContent) {
            document.querySelector("#pdp-extra-content").style.top = `${
              headerGroup.clientHeight + 20
            }px`;
          }
        }

        oldScroll = Math.max(window.scrollY, 0);
      });
    }
  }

  listenVariantChange() {
    window.addEventListener(
      "kt.product.variant.change",
      (event) => {
        const selectedVariant = event.detail;

        if (selectedVariant.featured_media) {
          this.main.slideTo(selectedVariant.featured_media.position - 1);
        }
      },
      false
    );
  }

  async initFullScreenGallery() {
    if (this.dataset.fullScreen === "false") return;

    const vendorScript = document.querySelector(
      'script[src*="vendor-glightbox.min"]'
    );

    vendorScript.onload = () => {
      window.GLightbox({
        selector: `[data-gallery="gallery-${this.dataset.productId}"]`,
        loop: true,
        openEffect: "zoom",
        closeEffect: "fade",
        slideEffect: this.dataset.fullScreenEffect,
      });
    };
  }
}
customElements.define("product-media-gallery", ProductMediaGallery);

class QtySwitcher extends HTMLElement {
  constructor() {
    super();

    this.qtyInput = this.querySelector("input");
    this.minusBtn = this.querySelector("button.btn-qty-minus");
    this.plusBtn = this.querySelector("button.btn-qty-plus");

    this.qtyInput.addEventListener("change", () => this.onQtyInputChange());
    this.minusBtn.addEventListener("click", () => this.onMinusBtnClick());
    this.plusBtn.addEventListener("click", () => this.onPlusBtnClick());

    window.addEventListener("kt.product.variant.change.newDoc", (event) =>
      this.onVariantChange(event)
    );
  }

  onQtyInputChange() {
    this.validateButtons();
  }

  onMinusBtnClick() {
    this.qtyInput.value = Number(this.qtyInput.value) - 1;
    this.validateButtons();
    this.qtyInput.dispatchEvent(new CustomEvent("change"));
  }

  onPlusBtnClick() {
    this.qtyInput.value = Number(this.qtyInput.value) + 1;
    this.validateButtons();
    this.qtyInput.dispatchEvent(new CustomEvent("change"));
  }

  validateButtons() {
    if (
      this.qtyInput.getAttribute("min") &&
      Number(this.qtyInput.value) <= Number(this.qtyInput.getAttribute("min"))
    ) {
      this.minusBtn.disabled = true;
      this.qtyInput.value = this.qtyInput.getAttribute("min");
    } else {
      this.minusBtn.disabled = false;
    }
    if (
      this.qtyInput.getAttribute("max") &&
      Number(this.qtyInput.value) >= Number(this.qtyInput.getAttribute("max"))
    ) {
      this.plusBtn.disabled = true;
      this.qtyInput.value = this.qtyInput.getAttribute("max");
    } else {
      this.plusBtn.disabled = false;
    }
  }

  onVariantChange(event) {
    if (!this.closest(".product-block-atc")) return;

    const newDoc = event.detail;
    const newQtyInput = newDoc.querySelector(
      ".product-block-atc qty-switcher input"
    );

    this.qtyInput.setAttribute("max", newQtyInput.getAttribute("max"));
    this.validateButtons();
  }
}
customElements.define("qty-switcher", QtySwitcher);

class ProductStockIndicator extends HTMLElement {
  constructor() {
    super();

    this.progressBar = this.querySelector(".progress-bar");
    this.animateProgressBar();
    this.handleVariantChange();
  }

  animateProgressBar() {
    setTimeout(() => {
      this.progressBar.style.width = this.progressBar.dataset.width;
    }, 250);
  }

  handleVariantChange() {
    window.addEventListener("kt.product.variant.change", async () => {
      this.querySelector(".product-block-stock-indicator-inner").style.opacity =
        ".25";
    });

    window.addEventListener("kt.product.variant.change.newDoc", async (e) => {
      const newDoc = e.detail;

      this.replaceWith(
        newDoc.querySelector('[id*="product-block-stock-indicator"]')
      );
      this.animateProgressBar();
    });
  }
}
customElements.define("product-stock-indicator", ProductStockIndicator);

class ProductQuantityBreaks extends HTMLElement {
  constructor() {
    super();

    this.handleInputChange();
    this.handleVariantChange();
  }

  handleInputChange(btn) {
    this.querySelectorAll("input").forEach((input) => {
      input.addEventListener("change", () => {
        const qtyField = input
          .closest("form")
          .querySelector('[name="quantity"]');
        qtyField.value = input.value;
        qtyField.dispatchEvent(new CustomEvent("change"));

        const atcBtn = this.closest("form").querySelector(".btn-atc");

        setTimeout(() => {
          atcBtn.classList.add("animate__animated", "animate__shakeX");
        }, 250);

        setTimeout(() => {
          atcBtn.classList.remove("animate__animated", "animate__shakeX");
        }, 1500);
      });
    });
  }

  handleVariantChange() {
    window.addEventListener("kt.product.variant.change", async () => {
      this.querySelector(".product-block-quantity-breaks-list").style.opacity =
        ".25";
    });

    window.addEventListener("kt.product.variant.change.newDoc", async (e) => {
      const newDoc = e.detail;

      this.replaceWith(newDoc.querySelector("product-quantity-breaks"));
      this.handleInputChange();
    });
  }
}
customElements.define("product-quantity-breaks", ProductQuantityBreaks);

class ProductQuickButton extends HTMLElement {
  constructor() {
    super();

    this.btn = this.querySelector(".btn-quick-view");
    this.modalCustomElem = document.querySelector("product-quick-view-modal");

    this.btn.addEventListener("click", async (event) =>
      this.fetchProductData(event)
    );
  }

  async fetchProductData(event) {
    event.preventDefault();

    this.setLoading(true);

    const response = await fetch(this.btn.dataset.productUrl);

    if (response.ok) {
      const text = await response.text();
      const newDoc = new DOMParser().parseFromString(text, "text/html");

      document.querySelector("product-quick-view-modal").showModal(newDoc);
    } else {
      // TODO: Handle Errors
    }

    this.setLoading(false);
  }

  setLoading(isLoading) {
    if (isLoading) {
      this.btn.classList.add("loading");
      this.btn.disabled = true;
      this.btn.setAttribute("aria-busy", "true");
    } else {
      this.btn.classList.remove("loading");
      this.btn.disabled = false;
      this.btn.removeAttribute("aria-busy");
    }
  }
}
customElements.define("product-quick-view-button", ProductQuickButton);

class ProductQuickViewModal extends HTMLElement {
  constructor() {
    super();

    this.modalElem = document.querySelector("#quick-view-modal");

    this.modalElem.addEventListener("hidden.bs.modal", () => {
      this.modalElem.querySelector(".product").innerHTML =
        "<div data-quick-view-contents></div>";
    });

    window.addEventListener("kt.cart.added", () => {
      window.bootstrap.Modal.getOrCreateInstance(this.modalElem).hide();
    });
  }

  async showModal(newDoc) {
    this.modalElem
      .querySelector("[data-quick-view-contents]")
      .replaceWith(
        newDoc.querySelector(".product-main [data-quick-view-contents]")
      );

    this.modalElem
      .querySelector(".product-title")
      .setAttribute("id", "quick-view-modal-label");

    this.modalElem
      .querySelectorAll(".collapse-wrapper")
      .forEach((collapseWrapper) => {
        collapseWrapper
          .querySelector('[data-bs-toggle="collapse"]')
          .setAttribute("aria-expanded", "false");
        collapseWrapper.querySelector(".collapse").classList.remove("show");
      });

    this.modalElem
      .querySelectorAll('.product-options [name*="option"]')
      .forEach((elem) => {
        elem.setAttribute("name", `${elem.name}-qv`);
        elem.setAttribute("id", `${elem.id}-qv`);
      });

    this.modalElem
      .querySelectorAll(".product-options label")
      .forEach((label) => {
        label.setAttribute("for", `${label.getAttribute("for")}-qv`);
      });

    this.modalElem.querySelectorAll(".collapse").forEach((elem) => {
      elem.addEventListener("shown.bs.collapse", () => {
        elem
          .closest(".product-block-collapse")
          ?.scrollIntoView({ behavior: "smooth" });
      });
    });

    window.bootstrap.Modal.getOrCreateInstance(this.modalElem).show();
    window.dispatchEvent(new CustomEvent("kt.product.quick_view.modal_shown"));
  }
}
customElements.define("product-quick-view-modal", ProductQuickViewModal);

class ProductDropupSelector extends HTMLElement {
  constructor() {
    super();

    this.productCard = this.closest(".product-card");
    this.dropdownBtn = this.querySelector(".dropdown-toggle");

    this.querySelector(".dropdown-menu").style.maxHeight =
      this.productCard.offsetHeight - this.dropdownBtn.offsetHeight - 2 + "px";

    this.addEventListener("show.bs.dropdown", (event) => {
      const isMobile = window.matchMedia("(max-width: 499px").matches;

      if (isMobile) {
        event.preventDefault();
        this.initOffcanvas();
      } else {
        this.productCard.querySelector(
          ".product-card-img-wrapper"
        ).style.opacity = ".2";
      }
    });
    this.addEventListener("hide.bs.dropdown", (event) => {
      const isMobile = window.matchMedia("(max-width: 499px").matches;

      if (isMobile) {
        event.preventDefault();
        this.removeOffcanvas();
      } else {
        this.productCard.querySelector(
          ".product-card-img-wrapper"
        ).style.opacity = "1";
      }
    });

    this.querySelectorAll(".dropdown-menu button").forEach((btn) => {
      btn.addEventListener("click", () => this.addToCart(btn));
    });
  }

  async addToCart(btn) {
    window.bootstrap.Dropdown.getOrCreateInstance(this).hide();

    this.dropdownBtn.classList.add("loading");
    this.dropdownBtn.disabled = true;
    this.dropdownBtn.setAttribute("aria-busy", "true");

    const items = [
      {
        id: Number(btn.dataset.variantId),
        quantity: 1,
      },
    ];

    await document.querySelector("cart-container").add({ items });

    this.dropdownBtn.classList.remove("loading");
    this.dropdownBtn.disabled = false;
    this.dropdownBtn.setAttribute("aria-busy", "false");
  }

  initOffcanvas() {
    const html = `
      <div id="product-dropup-select-offcanvas" class="offcanvas offcanvas-bottom" tabindex="-1" aria-labelledby="product-dropup-select-offcanvas-title">
        <div class="offcanvas-header">
          <h5 class="offcanvas-title" id="product-dropup-select-offcanvas-title">
            ${this.dropdownBtn.textContent}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" class="svg-icon-x" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        <div class="offcanvas-body p-0">
          <ul class="dropdown-menu">
            ${this.querySelector(".dropdown-menu").innerHTML}
          </ul>
        </div>
      </div>
    `;
    document.body.insertAdjacentHTML("beforeend", html);

    window.bootstrap.Offcanvas.getOrCreateInstance(
      "#product-dropup-select-offcanvas"
    ).show();

    document
      .querySelectorAll(
        "#product-dropup-select-offcanvas .dropdown-menu button"
      )
      .forEach((btn) => {
        btn.addEventListener("click", () => {
          this.addToCart(btn);
          window.bootstrap.Offcanvas.getOrCreateInstance(
            "#product-dropup-select-offcanvas"
          ).hide();
        });
      });

    document
      .querySelector("#product-dropup-select-offcanvas")
      .addEventListener("hidden.bs.offcanvas", () => {
        document.querySelector("#product-dropup-select-offcanvas").remove();
      });
  }
}
customElements.define("product-dropup-selector", ProductDropupSelector);

class CrossSells extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('input[type="checkbox"').forEach((checkbox) => {
      checkbox.addEventListener("change", () =>
        this.onCheckboxChange(checkbox)
      );
    });

    this.querySelectorAll('select[name="variant-id"').forEach((select) => {
      select.addEventListener("change", () => this.onChangeVariant(select));
    });

    this.querySelectorAll(".btn-atc").forEach((btn) => {
      btn.addEventListener("click", () => this.addToCart(btn));
    });
  }

  onChangeVariant(select) {
    const variantImage = select[select.selectedIndex].dataset.variantImage;

    if (variantImage.length) {
      select
        .closest(".product-card")
        .querySelector(".product-card-img-wrapper img")
        .setAttribute("src", variantImage);
    }

    this.updateTotalPrice();
  }

  onCheckboxChange(checkbox) {
    if (checkbox.checked) {
      checkbox
        .closest(".product-card")
        .setAttribute("data-is-selected", "true");
    } else {
      checkbox
        .closest(".product-card")
        .setAttribute("data-is-selected", "false");
    }
    this.updateTotalPrice();
  }

  updateTotalPrice() {
    let totalPrice = 0;
    let totalComparePrice = 0;

    this.querySelectorAll('input[type="checkbox"').forEach((checkbox) => {
      if (checkbox.checked) {
        const inputHidden = checkbox
          .closest(".product-card")
          .querySelector('input[name="variant-id"][type="hidden"]');
        if (inputHidden) {
          totalPrice += Number(inputHidden.dataset.price);
          totalComparePrice += Number(inputHidden.dataset.compareAtPrice);
        }

        const select = checkbox
          .closest(".product-card")
          .querySelector('select[name="variant-id"]');
        if (select) {
          totalPrice += Number(select[select.selectedIndex].dataset.price);
          totalComparePrice += Number(
            select[select.selectedIndex].dataset.compareAtPrice
          );
        }
      }
    });

    this.querySelectorAll("[data-total-price]").forEach((elem) => {
      elem.textContent = `${window.Shopify.formatMoney(totalPrice)}`.replace(
        ".00",
        ""
      );
    });

    this.querySelectorAll("[data-total-compare-price]").forEach((elem) => {
      elem.textContent = `${window.Shopify.formatMoney(
        totalComparePrice
      )}`.replace(".00", "");
    });

    this.querySelectorAll("[data-total-savings]").forEach((elem) => {
      elem.textContent = `${window.Shopify.formatMoney(
        totalComparePrice - totalPrice
      )}`.replace(".00", "");
    });

    if (totalPrice === 0) {
      this.querySelector(".btn-atc").disabled = true;
    } else {
      this.querySelector(".btn-atc").disabled = false;
    }

    if (totalComparePrice > totalPrice) {
      this.querySelectorAll("[data-total-compare-price]").forEach((elem) => {
        elem.closest("s").removeAttribute("hidden");
      });
      this.querySelectorAll("[data-total-savings]").forEach((elem) => {
        elem
          .closest(".cross-sells-footer-total-savings")
          .removeAttribute("hidden");
      });
    } else {
      this.querySelectorAll("[data-total-compare-price]").forEach((elem) => {
        elem.closest("s").setAttribute("hidden", "hidden");
      });
      this.querySelectorAll("[data-total-savings]").forEach((elem) => {
        elem
          .closest(".cross-sells-footer-total-savings")
          .setAttribute("hidden", "hidden");
      });
    }
  }

  async addToCart(atcBtn) {
    atcBtn.style.width = `${atcBtn.clientWidth}px`;
    atcBtn.classList.add("loading");
    atcBtn.disabled = true;
    atcBtn.setAttribute("aria-busy", "true");

    const items = [];

    this.querySelectorAll('input[type="checkbox"').forEach((checkbox) => {
      if (checkbox.checked) {
        const id = Number(
          checkbox.closest(".product-card").querySelector('[name="variant-id"]')
            .value
        );

        items.push({
          id,
          quantity: 1,
        });
      }
    });

    await document.querySelector("cart-container").add({ items });

    atcBtn.style.width = "";
    atcBtn.classList.remove("loading");
    atcBtn.disabled = false;
    atcBtn.setAttribute("aria-busy", "false");
  }
}
customElements.define("cross-sells", CrossSells);

class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.handleCarouselHover();
  }

  handleCarouselHover() {
    if (window.matchMedia("(pointer: coarse)").matches) return;

    const bsCarousel = window.bootstrap.Carousel.getOrCreateInstance(
      this.querySelector(".product-card-img-wrapper .carousel")
    );
    const carouselInner = this.querySelector(
      ".product-card-img-wrapper .carousel-inner"
    );
    let myInterval;

    carouselInner.addEventListener("mouseenter", () => {
      setTimeout(() => {
        bsCarousel.next();
      }, 500);

      myInterval = setInterval(() => {
        bsCarousel.next();
      }, 2000);
    });

    carouselInner.addEventListener("mouseleave", () => {
      clearInterval(myInterval);
    });
  }
}
customElements.define("product-card", ProductCard);

class FileUploadPersonalizationField extends HTMLElement {
  constructor() {
    super();

    this.loadStyleScripts();

    const vendorScript = document.querySelector(
      'script[src*="plugin-image-preview"]'
    );
    vendorScript.onload = () => {
      this.init();
    };

    window.addEventListener("kt.product.quick_view.modal_shown", () =>
      this.init()
    );
  }

  loadStyleScripts() {
    if (document.querySelector('script[src*="plugin-image-preview"]')) return;

    const style1 = document.createElement("link");
    style1.setAttribute(
      "href",
      "https://cdn.jsdelivr.net/npm/filepond@4.31.1/dist/filepond.min.css"
    );
    style1.setAttribute("rel", "stylesheet");
    style1.setAttribute(
      "integrity",
      "sha256-a95jYCBL4++k1XyLYgulKmY33bIJIVYMsJO/RNytaJM="
    );
    style1.setAttribute("crossorigin", "anonymous");
    document.head.appendChild(style1);

    const style2 = document.createElement("link");
    style2.setAttribute(
      "href",
      "https://cdn.jsdelivr.net/npm/filepond-plugin-image-preview@4.6.12/dist/filepond-plugin-image-preview.min.css"
    );
    style2.setAttribute("rel", "stylesheet");
    style2.setAttribute(
      "integrity",
      "sha256-YsO8aMI20vSizdmc2mmWx2DU1wof4v60Nwy7hIBvdM8="
    );
    style2.setAttribute("crossorigin", "anonymous");
    document.head.appendChild(style2);

    const script1 = document.createElement("script");
    script1.setAttribute(
      "src",
      "https://cdn.jsdelivr.net/npm/filepond@4.31.1/dist/filepond.min.js"
    );
    script1.setAttribute(
      "integrity",
      "sha256-6yXpr8+sATA4Q2ANTyZmpn4ZGP7grbIRNpe9s0Y+iO0="
    );
    script1.setAttribute("crossorigin", "anonymous");
    script1.setAttribute("defer", "defer");
    document.head.appendChild(script1);

    const script2 = document.createElement("script");
    script2.setAttribute(
      "src",
      "https://cdn.jsdelivr.net/npm/filepond-plugin-image-preview@4.6.12/dist/filepond-plugin-image-preview.min.js"
    );
    script2.setAttribute(
      "integrity",
      "sha256-1vQHytMrpOsKFyUUPuEVhxeNH6UhMX3uNetDRvlSpwU="
    );
    script2.setAttribute("crossorigin", "anonymous");
    script1.setAttribute("defer", "defer");
    document.head.appendChild(script2);
  }

  async init() {
    await new Promise((resolve) => setTimeout(resolve, 200));

    window.FilePond.registerPlugin(window.FilePondPluginImagePreview);
    const inputElem = this.querySelector('input[type="file"]');

    window.FilePond.create(inputElem, {
      storeAsFile: true,
      labelIdle: this.querySelector("[data-label-text]").innerHTML,
    });
  }
}
customElements.define(
  "file-upload-personalization-field",
  FileUploadPersonalizationField
);

// Product block collapses
if (window.matchMedia("(max-width: 1199px").matches) {
  document.querySelectorAll(".product-block-collapse").forEach((elem) => {
    elem
      .querySelector(".collapse")
      .addEventListener("shown.bs.collapse", () => {
        elem.scrollIntoView({ behavior: "smooth" });
      });
  });
}

// Shopify Subscriptions app
const adjustShopifySubscriptionsStyling = () => {
  document
    .querySelectorAll('.shopify_subscriptions_app_block [type="radio"]')
    .forEach((radio) => {
      radio.classList.add("form-check-input");
    });
};
adjustShopifySubscriptionsStyling();
window.addEventListener(
  "kt.product.quick_view.modal_shown",
  adjustShopifySubscriptionsStyling
);